<form id="searchForm" [formGroup]="searchForm" autocomplete="off" class="search-field">
  <div class="form-inline">
    <input id="filter" name="filter" class="form-control search" type="text" formControlName="filter" [placeholder]="placeholderText | translate" [attr.aria-label]="placeholderText | translate"/>
    <span class="e-icons icon-search"></span>
  </div>
</form>
